import { css } from "@emotion/css";

import { grey } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

import arrowIconSrc from "./arrow-icon.svg";

export const createMoreMenuPageStyles = ({
  spacing,
  palette,
  typography,
}: Theme) => {
  return {
    nav: css({
      marginTop: spacing(3),
    }),
    navItem: css({
      borderTop: `1px solid ${grey[200]}`,
      "&:last-child": {
        borderBottom: `1px solid ${grey[200]}`,
      },
    }),
    button: css({
      appearance: "none",
      outline: "none",
      background: "transparent",
      border: "none",
      fontFamily: typography.fonts.body,
      width: "100%",
    }),
    link: css({
      padding: spacing(2),
      textDecoration: "none",
      color: palette.default.text,
      fontSize: typography.pxToRem(16),
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontWeight: typography.fontWeight.medium,
      "&:after": {
        content: "''",
        width: 8,
        height: 12,
        backgroundImage: `url(${arrowIconSrc})`,
      },
    }),
  };
};
